module.exports = __webpack_public_path__ + "public/img/er_wei_ma.4105a3b2.jpg";